import { Paper, Typography } from "@mui/material";
import DrawerMenu from "../components/DrawerMenu";
import CharacterLibrary from "../components/CharacterLibrary";

export default function Characters() {
  return (
    <DrawerMenu>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Character library
      </Typography>
      <Paper sx={{ p: 3 }}>
        <CharacterLibrary />
      </Paper>
    </DrawerMenu>
  );
}
